import { render, staticRenderFns } from "./build_starkid_dashboard.vue?vue&type=template&id=a9fc0a88&scoped=true"
import script from "./build_starkid_dashboard.vue?vue&type=script&lang=js"
export * from "./build_starkid_dashboard.vue?vue&type=script&lang=js"
import style0 from "./build_starkid_dashboard.vue?vue&type=style&index=0&id=a9fc0a88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9fc0a88",
  null
  
)

export default component.exports